<div mat-dialog-content><b>{{confirmMessage}}</b></div>
<nsc-spacer size="sm"></nsc-spacer>
<div class=mat-dialog-actions>
  <button mat-button class="nsc-button" type="button" (click)="dialogRef.close(true)">Yes</button>
  <button mat-button class="nsc-button" type="button" (click)="dialogRef.close(false)">No</button>
</div>